import { render, staticRenderFns } from "./StopRecoveryList.vue?vue&type=template&id=56fc2f70&scoped=true"
import script from "./StopRecoveryList.vue?vue&type=script&lang=js"
export * from "./StopRecoveryList.vue?vue&type=script&lang=js"
import style0 from "./StopRecoveryList.vue?vue&type=style&index=0&id=56fc2f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fc2f70",
  null
  
)

export default component.exports